const stop = () => {
  const body = document.body;
  const html = document.documentElement;
  body.style.overflow = "hidden";
  body.style.touchAction = "none";
  html.style.overflow = "hidden";
  html.style.touchAction = "none";
};
const move = () => {
  const body = document.body;
  const html = document.documentElement;
  body.style.overflow = "";
  body.style.touchAction = "";
  html.style.overflow = "";
  html.style.touchAction = "";
}; //出现滚动条
export default {
  name: "popDialog",
  props: {
    show: Boolean,
    closeModel: {
      default: true,
      type: Boolean
    },
    //是否可以通过点击 modal 关闭 Dialog
    classname: {
      default: "",
      type: String
    },
    modal: {
      default: true,
      type: Boolean
    },
    width: {
      type: String,
      default: "90%"
    },
    height: {
      type: String,
      default: "auto"
    },
    isLoc: {
      type: String,
      default: "center"
    },
    showClose: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    show(bool) {
      this.$nextTick(() => {
        const pop = document.getElementById("pop");
        if (bool) {
          stop();
        } else {
          move();
        }
        if (pop.append) {
          pop.append(this.$el);
        } else {
          pop.appendChild(this.$el);
        }
      });
    }
  }
};